
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10 1.667c-1.84 0-3.333 1.544-3.333 3.448 0 .629.162 1.218.446 1.725C4.965 6.268 2.5 7.926 2.5 10.289c0 2.67 2.616 3.898 4.842 3.317.72-.188 1.08-.282 1.181-.172.39.423-.735 2.53-.937 2.947-.382.785-.573 1.177-.425 1.422.351.582 5.182.821 5.678 0 .148-.245-.043-.637-.425-1.422-.202-.416-1.327-2.524-.937-2.947.102-.11.462-.016 1.181.172 2.216.578 4.842-.674 4.842-3.317 0-2.346-2.472-4.02-4.613-3.45a3.525 3.525 0 00.446-1.724c0-1.904-1.492-3.448-3.333-3.448z","stroke":"#fff","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    